import React from "react";
import { useFieldArray, Controller } from "react-hook-form";
import { Form, Collapse, Input, Select, Space, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;

const ServerPathConfigurationElement = (props) => {
  const { control, errors, watch } = props;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "job.serverPath.dynamicPathSegments",
  });

  let jobParametersArray = watch("job.jobParameters");

  const parameterType = (index) => {
    switch (watch(`job.serverPath.dynamicPathSegments.${index}.segmentType`)) {
      case "Fixed":
        return (
          <Form.Item
            {...formItemLayout}
            label="Segment Value"
            help={
              errors.job?.serverPath?.dynamicPathSegments?.[index]?.segmentValue
                ?.message
            }
            required
            validateStatus={
              errors.job?.serverPath?.dynamicPathSegments?.[index]?.segmentValue
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`job.serverPath.dynamicPathSegments.${index}.segmentValue`}
              render={({ field }) => (
                <Input
                  style={{ width: "180%" }}
                  placeholder="Segment Value"
                  {...field}
                />
              )}
            />
          </Form.Item>
        );

      case "Parameter":
        return (
          <Form.Item
            {...formItemLayout}
            label="Segment Value"
            help={
              errors.job?.serverPath?.dynamicPathSegments?.[index]?.segmentValue
                ?.message
            }
            required
            validateStatus={
              errors.job?.serverPath?.dynamicPathSegments?.[index]?.segmentValue
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`job.serverPath.dynamicPathSegments.${index}.segmentValue`}
              render={({ field: { onChange, value } }) => (
                <Select
                  onChange={onChange}
                  value={value}
                  placeholder="Segment Value"
                  allowClear
                  style={{ width: "180%" }}
                >
                  {jobParametersArray !== undefined
                    ? jobParametersArray.map((elem) => (
                        <Option value={elem.name}>{elem.name}</Option>
                      ))
                    : undefined}
                </Select>
              )}
            />
          </Form.Item>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["5"]} expandIconPosition="end">
          <Panel header="Server Path Configuration" key="5">
            <Form.Item
              {...formItemLayout}
              label="Root Path"
              help={errors.job?.serverPath?.rootPath?.message}
              required
              validateStatus={errors.job?.serverPath?.rootPath ? "error" : ""}
            >
              <Controller
                control={control}
                name="job.serverPath.rootPath"
                render={({ field }) => (
                  <Input {...field} placeholder="Root Path" />
                )}
              />
            </Form.Item>

            <Form.Item {...formItemLayout} label="Dynamic Path Segments">
              {fields?.map((item, index) => {
                return (
                  <>
                    <div>
                      <Space
                        key={item.id}
                        style={{
                          display: "Block",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...formItemLayout}
                          label="Segment Type"
                          help={
                            errors.job?.serverPath?.dynamicPathSegments?.[index]
                              ?.segmentType?.message
                          }
                          required
                          validateStatus={
                            errors.job?.serverPath?.dynamicPathSegments?.[index]
                              ?.segmentType
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.serverPath.dynamicPathSegments.${index}.segmentType`}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                style={{ width: "180%" }}
                                showSearch
                                placeholder="Segment Type"
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                value={value}
                              >
                                <Option value="Fixed">Fixed</Option>
                                <Option value="Parameter">Parameter</Option>
                              </Select>
                            )}
                          />
                        </Form.Item>

                        {parameterType(index)}

                        <Form.Item
                          label="Override Date format"
                          {...formItemLayout}
                        >
                          <Controller
                            control={control}
                            name={`job.serverPath.dynamicPathSegments.${index}.overrideDateFormat`}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                style={{ width: "180%" }}
                                allowClear
                                showSearch
                                placeholder="Override Date Format"
                                onChange={onChange}
                                optionFilterProp="children"
                                value={value}
                              >
                                <Option value="yyyyMMdd">yyyyMMdd</Option>
                                <Option value="yyyy-MM-dd">yyyy-MM-dd</Option>
                                <Option value="dd-MM-yyyy">dd-MM-yyyy</Option>
                                <Option value="MM-dd-yyyy">MM-dd-yyyy</Option>
                                <Option value="yyyy/MM/dd">yyyy/MM/dd</Option>
                                <Option value="dd/MM/yyyy">dd/MM/yyyy</Option>
                                <Option value="MM/dd/yyyy">MM/dd/yyyy</Option>
                              </Select>
                            )}
                          />
                        </Form.Item>

                        <MinusCircleOutlined onClick={() => remove(index)} />
                      </Space>
                    </div>
                  </>
                );
              })}
              <Button
                block
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  append({
                    segmentType: undefined,
                    overrideDateFormat: null,
                  })
                }
              >
                Add Dynamic Path Segments
              </Button>
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default ServerPathConfigurationElement;
